import { Stack } from "@fluentui/react";
import React from "react";
import { BaseProps, validateProps } from "../../../shared/props";
import { Breadcrumb, BreadcrumbItemStyle, BreadcrumbProps } from "../../Breadcrumb/Breadcrumb";
import { getBannerBreadcrumbTitleColumnStyles } from "../BannerBreadcrumbTitleColumn/BannerBreadcrumbTitleColumn.styles";

export interface BannerBreadcrumbTitleColumnProps extends BaseProps {
    /**
     * Breadcrumb props to create a Breadcrumb component title.
     */
    readonly breadcrumbTitleProps: BreadcrumbProps;
}

export const BannerBreadcrumbTitleColumn: React.FC<BannerBreadcrumbTitleColumnProps> = ({
    breadcrumbTitleProps,
    ...otherProps
}) => {

    validateProps("BannerBreadcrumbTitleColumn", otherProps);

    return (
        <Stack styles={getBannerBreadcrumbTitleColumnStyles()}>
            <Breadcrumb maxDisplayedItems={5} itemStyle={BreadcrumbItemStyle.Title} {...breadcrumbTitleProps} />
        </Stack>
    );
};
